import { AxiosResponse } from 'axios';

import { client } from '../client';
import { PresignedURLResponse } from '../common/types';

import { termEndPoints } from './endpoints';
import {
  GetDocumentPresignedURLResponse,
  GetRequirementQuestionnaireRequest,
  RequirementQuestionnaireResponse,
  SubmitRequirementQuestionnaireResponse,
  TermCustomerRequirementsRequest,
  TermCustomerRequirementsResponse,
  TermDocPresignedURLRequest,
  TermDocumentRequest,
  TermDocumentResponse
} from './types';

export const termOpsAPIs = {
  // Get all requirements on page load
  getCustomerRequirements: (
    payload: TermCustomerRequirementsRequest
  ): Promise<AxiosResponse<TermCustomerRequirementsResponse>> => {
    return client.get<TermCustomerRequirementsResponse>(
      termEndPoints.customerRequirements,
      payload
    );
  },
  // If initial GET requirements on page load results empty, trigger POST to create initial requirements
  // If still empty, consider no requirements mapped yet
  createInitialCustomerRequirements: (
    payload: TermCustomerRequirementsRequest
  ): Promise<
    AxiosResponse<TermCustomerRequirementsResponse, TermCustomerRequirementsRequest>
  > => {
    return client.post<
      TermCustomerRequirementsResponse,
      TermCustomerRequirementsRequest
    >(termEndPoints.createInitialRequirements, payload);
  },
  // Get presigned URLS for files to be uploaded to S3 bucket
  getDocPresignedURL: (
    payload: TermDocPresignedURLRequest
  ): Promise<AxiosResponse<PresignedURLResponse, TermDocPresignedURLRequest>> => {
    return client.post<PresignedURLResponse, TermDocPresignedURLRequest>(
      termEndPoints.docPresignedURL,
      payload
    );
  },
  // Notify backend after s3 upload success to create uploaded documents records
  createRequirementDoc: (
    payload: TermDocumentRequest
  ): Promise<AxiosResponse<TermDocumentResponse, TermDocumentRequest>> => {
    return client.post<TermDocumentResponse, TermDocumentRequest>(
      termEndPoints.document,
      payload
    );
  },
  // Get Saved Form Data and Form Config
  getRequirementQuestionnaire: (
    query: GetRequirementQuestionnaireRequest
  ): Promise<RequirementQuestionnaireResponse> => {
    return client.get(termEndPoints.requirementQuestionnaireDocument, query);
  },
  // Save Form Data
  saveRequirementQuestionnaire: (
    query: GetRequirementQuestionnaireRequest,
    data: any
  ): Promise<RequirementQuestionnaireResponse> => {
    return client.post(termEndPoints.requirementQuestionnaireDocument, data, {
      params: query
    });
  },
  // Send OTP via SMS to confirm the form data
  submitRequirementQuestionnaire: (
    documentId: string
  ): Promise<SubmitRequirementQuestionnaireResponse> => {
    return client.post(termEndPoints.submitQuestionnaireDocument(documentId));
  },
  // Send OTP via WhatsApp to confirm the form data
  submitRequirementQuestionnaireWhatsApp: (
    documentId: string
  ): Promise<SubmitRequirementQuestionnaireResponse> => {
    return client.post(
      termEndPoints.submitQuestionnaireDocumentWhatsApp(documentId)
    );
  },

  // Confirm the form data
  confirmRequirementQuestionnaire: (
    questionnaireId: string,
    otp: string
  ): Promise<{ data: any; success: boolean }> => {
    return client.post(termEndPoints.confirmQuestionnaire(questionnaireId), {
      otp
    });
  },
  // Get presigned URL to view uploaded Documents
  getDocumentPresignedURL: (
    documentId: number
  ): Promise<GetDocumentPresignedURLResponse> => {
    return client.post(termEndPoints.docPresignedURL, {
      document_id: documentId
    });
  }
};
